import "./App.css";

import { Route, BrowserRouter as Router, Switch } from "react-router-dom";

import { Container } from "react-bootstrap";
import Evento from "./pages/event/event";
import Home from "./pages/home/Home";
import CanjeBonos from "./components/Bonos/canjeBonos";
import ListaEventos from "./pages/listaEventos/listaEventos";
/* import fondo from "./assets/Background_DreamingDreams.png"; */
//import Footer from './components/Footer/footer';
//, backgroundImage: `url(${fondo})`,backgroundSize:"cover"
import { Helmet } from "react-helmet";
/* import favicon from "./assets/Dreaming_TicketSquare_black_logo.ico"; */

function App() {
  return (
    <Container fluid style={{ paddingLeft: "0", paddingRight: "0" }}>
      <Helmet>
        <meta charset="utf-8" />ç
        <meta name="google-site-verification" content="WpjIxK4Sk3fFkX9jL81RUHqe33wiL7K95JMmK08WKWs" />
        <title>El-reguetonero</title>
        <meta property="og:title" content="El-reguetonero" />
        <meta name="description" content="No hay nada mejor para acabar el mes que darlo todo en este fiestón de Fabrik... ¡Disfruta del mejor reggaeton con el directo de Omar Montes y Zion & Lennox! Acompañados por Felix Klain, Elias y Moncho Chavea, Sasha y David Sanchez, vivirás una noche top que te dejará sin palabras... ¡Y con mil ganas de darlo todo en la pista de baile! ¡Consigue tus entradas para El Reguetonero en Fabrik, Madrid!." />
        {/* <link rel="icon" href={favicon} /> */}
        <link rel="canonical" href="https://El-reguetonero.es/" />
      </Helmet>
      <Router>
        <Switch>
          {/* <Route exact={true} path="/" component={Home} />
          <Route
            path="/ciclo/:ciclo"
            render={({ match }) => {
              return <ListaEventos ciclo_key={match.params.ciclo} />;
            }}
          /> */}
          <Route
            exact={true}
            path="/"
            render={({ match }) => <Evento eventoID={"6320e87712399740282141ea"} />}
          />
          {/* <Route
            exact={true}
            path="/evento/:eventoId"
            render={({ match }) => <Evento eventoID={match.params.eventoId} />}
          /> */}
          {/* <Route path="/canjeBonos" component={CanjeBonos} /> */}
        </Switch>
      </Router>
    </Container>
  );
}

export default App;
